import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ModalComponent } from '@carm/shared/components/modal/modal.component';
import { BasePageComponent } from '@carm/_utils/base-page.component';

@Injectable()
export class BackButtonGuard  {

  // configre any legal routes not covered by guard rules
  // ignoreRoutes: string[] = [
  //   RoutesConst.UploadDocuments_StepThree,
  // ];

  constructor(
    private matDialog: MatDialog,
    private translateService: TranslateService,
  ) {

  }
  canDeactivate(
    component: BasePageComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if(!component.navigationButtonClicked) {
        return true;
      }

      const dialogRef = this.matDialog.open(ModalComponent, {
        data: component.backButtonPopupConfig
      });

      return dialogRef
        .afterClosed().pipe(
        map((buttonId: string) => {
          //console.log(buttonId)
          if (buttonId === 'cancel') {
            return false;
          }
          else {
            return true;
          }
        }));
  }
}
